import { put, call } from 'redux-saga/effects';

import * as actions from '@actions/user';
import { getUserAccount } from '@api/user';
import accountModel from '@models/Account';

export const handleGetUserAccountSaga = function* ({ payload }) {
  const response = yield call(getUserAccount, payload);
  yield put(actions.getUserAccountSuccess(accountModel(response)));
};
